import React, { useImperativeHandle, useRef, useState } from "react";
import MemberSummaryTipDialog from "@icoach/landingPage/dialog/MemberSummaryTipDialog";
import AppointmentCoachDialog from "@icoach/landingPage/dialog/AppointmentCoachDialog";
import AppointmentContactDialog from "@icoach/appointment/dialog/AppointmentContactDialog";
import InBodyStartScanDialogs from "@icoach/inbody/dialog/InBodyStartScanDialogs";
import SendSmsDialog from "@icoach/components/dialog/SendSmsDialog";
import { isEqual, isFunction } from "@util/utils";
import CheckinDialog from "@icoach/landingPage/dialog/CheckinDialog";
import CheckoutDialog from "@icoach/landingPage/dialog/CheckoutDialog";
import AppointmentFormDialog from "@icoach/landingPage/dialog/AppointmentFormDialog";
import AppointmentFigureAnalysisFormDialog from "@icoach/landingPage/dialog/AppointmentFigureAnalysisFormDialog";

const SENDSMS = "sendSMS";
const MEMBERSUMMARY = "memberSummary";
const APPOINTMENTCOACH = "appointmentCoach";
const APPOINTMENTCONTACT = "appointmentContact";
const INBODYSTARTSCAN = "InBodyStartScan";
const CHECKIN = "checkin";
const CHECKOUT = "checkout";
const APPOINTMENTFORM = "appointmentForm";
const APPOINTMENTFIGUREANALYSISFORM = "appointmentFigureAnalysisForm";

const LandingDialogBox = React.forwardRef((props, ref) => {
	const [openDialog, setOpenDialog] = useState(null);
	const [sourceData, setSourceData] = useState(null);
	const [options, setOptions] = useState(null);

	const refreshRef = useRef(null);

	const handleDialogClose = () => {
		setOpenDialog(null);
		setSourceData(null);
	};

	const doRefresh = (...arg) => {
		if (isFunction(refreshRef.current)) {
			setTimeout(() => refreshRef.current(...arg), 0);
		}
	};

	useImperativeHandle(
		ref,
		() => {
			return {
				openSmsDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(SENDSMS);
				},
				openMemberSummaryDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(MEMBERSUMMARY);
				},
				openAppointmentCoachDialog: (targetData, opts) => {
					setSourceData(targetData);
					setOptions(opts);
					setOpenDialog(APPOINTMENTCOACH);
				},
				openAppointmentContactDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(APPOINTMENTCONTACT);
				},
				openInBodyStartScanDialogs: targetData => {
					setSourceData(targetData);
					setOpenDialog(INBODYSTARTSCAN);
				},
				openCheckinDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(CHECKIN);
				},
				openCheckoutDialog: targetData => {
					setSourceData(targetData);
					setOpenDialog(CHECKOUT);
				},
				openAppointmentFormDialog: (targetData, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetData);
					setOpenDialog(APPOINTMENTFORM);
				},
				openAppointmentFigureAnalysisFormDialog: (targetData, refreshFn) => {
					refreshRef.current = refreshFn;
					setSourceData(targetData);
					setOpenDialog(APPOINTMENTFIGUREANALYSISFORM);
				},
				closeDialog: () => handleDialogClose(),
			};
		},
		// eslint-disable-next-line
		[],
	);

	return (
		<React.Fragment>
			<SendSmsDialog open={isEqual(openDialog, SENDSMS)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} isPeopleAppointment />
			<MemberSummaryTipDialog open={isEqual(openDialog, MEMBERSUMMARY)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<AppointmentCoachDialog open={isEqual(openDialog, APPOINTMENTCOACH)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} options={options || []} />
			<AppointmentContactDialog open={isEqual(openDialog, APPOINTMENTCONTACT)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<InBodyStartScanDialogs open={isEqual(openDialog, INBODYSTARTSCAN)} onClose={handleDialogClose} refresh={doRefresh} sourceData={sourceData} />
			<CheckinDialog open={isEqual(openDialog, CHECKIN)} onClose={handleDialogClose} sourceData={sourceData} refresh={doRefresh} />
			<CheckoutDialog open={isEqual(openDialog, CHECKOUT)} onClose={handleDialogClose} sourceData={sourceData} refresh={doRefresh} />
			<AppointmentFormDialog open={isEqual(openDialog, APPOINTMENTFORM)} sourceData={sourceData} onClose={handleDialogClose} refresh={doRefresh} />
			<AppointmentFigureAnalysisFormDialog open={isEqual(openDialog, APPOINTMENTFIGUREANALYSISFORM)} sourceData={sourceData} onClose={handleDialogClose} refresh={doRefresh} />
		</React.Fragment>
	);
});

export default LandingDialogBox;
